/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates store locator section
 *
 * <store-locator data-product-detail-data="ProductCtrl.productDetailData"> </store-locator>
 */
function storeLocatorDirective() {
    return {
        restrict: 'E',
        scope: {
            productDetailData: '=',
            isStoreLocatorEnabled: '=',
            isMobileMapShown: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: StoreLocatorController,
        template: require('./storeLocatorView.html')
    };
}

StoreLocatorController.$inject = [
    '$scope',
    'StoreLocatorService',
];
function StoreLocatorController (
    $scope,
    StoreLocatorService
) {

    this.$onInit = function () {
        let vm = this;
        const category = vm.productDetailData.category;
        const categoryName = category.name;
        vm.categoryId = category.id;
        vm.googleMapsProps = {
            'search_term': categoryName,
            'product': vm.productDetailData
        };
        StoreLocatorService.determineUserCoordinates().then(function (data) {
            vm.googleMapsProps.coordinates = data.coordinates;
            vm.googleMapsProps.zip_code = data.zip_code;
        });
    }
}

module.exports = storeLocatorDirective;

